// extracted by mini-css-extract-plugin
export default {"heading":"viewinterviewdetails_heading__+y+wr","schedulerBorder":"viewinterviewdetails_schedulerBorder__QoDhD","interview":"viewinterviewdetails_interview__9tbs7"};